module.exports = __webpack_public_path__ + "static/media/kitchenCleaning.9387eb04.png";